import React from 'react';
import { CardCell, CellsWrapper, Card } from 'modules/journey/card/styled';
import PropTypes from 'prop-types';

import {
  IdCell,
  HeightCell,
  NumberOfItemsCell,
  WeightCell,
  DistanceCell,
  LifgateCell,
  SideloadCell,
  AdditionalDocumentsCell,
  IncidentsCell,
  ShipperOrdersCell,
  CarrierRevenueCell,
  ShipperPriceCell,
  OntruckMarginCell,
  TopLoadCell,
  ZendeskTicketCell,
  BusinessCell,
} from 'modules/journey/card/cells';

import { UnassignedStopsRow, StopsRow } from 'modules/journey/card/rows';
import { IS_TENANT } from 'tenant/config';

const UnassignedJourneyCard = React.memo(({ style, journeyId, onCardClick }) => {
  const component = (
    <Card onClick={onCardClick} clickable data-e2e={`journey_card__${journeyId}`}>
      <CellsWrapper wrapperHeight={40} pLeft="XS" pRight="XS">
        <CardCell mRight="XS" cellColor="grey700" cellWidth={86}>
          <CarrierRevenueCell journeyId={journeyId} />
        </CardCell>
        <CardCell mRight="XS" cellColor="grey700" cellWidth={86}>
          <ShipperPriceCell journeyId={journeyId} />
        </CardCell>
        <CardCell cellColor="grey700" cellWidth={86}>
          <OntruckMarginCell journeyId={journeyId} />
        </CardCell>
        <CardCell cellWidth={'15,05,5'} />
        <CardCell cellWidth={10} mRight="XS" cellParent>
          {!IS_TENANT && <BusinessCell journeyId={journeyId} />}
        </CardCell>
        <CardCell cellWidth={75} mRight="S" alignRight cellColor="grey700">
          <NumberOfItemsCell journeyId={journeyId} showMax showEquivalents />
        </CardCell>
        <CardCell cellWidth={62} mRight="M" alignRight cellColor="grey700">
          <WeightCell journeyId={journeyId} showMax />
        </CardCell>
        <CardCell cellWidth={57} mRight="M" alignRight cellColor="grey700">
          <HeightCell journeyId={journeyId} />
        </CardCell>
        <CardCell cellWidth={100} mRight="S" cellParent>
          <LifgateCell journeyId={journeyId} mRight="XS" />
          <SideloadCell journeyId={journeyId} />
          <TopLoadCell journeyId={journeyId} />
          <AdditionalDocumentsCell journeyId={journeyId} />
        </CardCell>
        <CardCell cellWidth={'95,2,2'} />
        <CardCell cellWidth={195} mRight="XS" alignRight cellColor="grey700">
          <ZendeskTicketCell journeyId={journeyId} />
        </CardCell>
        <CardCell cellWidth={'40,2,2'} />
        <CardCell cellWidth={56} mRight="XS" alignRight cellColor="grey700">
          <IncidentsCell journeyId={journeyId} />
        </CardCell>
        <CardCell cellWidth={72} alignRight mRight="M" cellColor="grey700">
          <IdCell id={journeyId} />
        </CardCell>
        <CardCell cellPush />
        <CardCell alignRight cellOverflow>
          <DistanceCell journeyId={journeyId} />
        </CardCell>
      </CellsWrapper>
      <CellsWrapper wrapperHeight={32} pLeft="XS" pRight="XS" justifyContent="flex-start">
        <ShipperOrdersCell journeyId={journeyId} />
      </CellsWrapper>
      <CellsWrapper wrapperColumn>
        <StopsRow journeyId={journeyId} row={UnassignedStopsRow} />
      </CellsWrapper>
    </Card>
  );

  if (!style) {
    return component;
  }

  return <div style={style}>{component}</div>;
});

UnassignedJourneyCard.propTypes = {
  journeyId: PropTypes.number.isRequired,
  style: PropTypes.shape({}),
  onCardClick: PropTypes.func,
};

export default UnassignedJourneyCard;
